import React, { useState } from "react";
import "./sign-request-by-volume-signers-list-panel.pure.css";

import { GridColumn as Column } from "@progress/kendo-react-grid";
import { SimpleKendoGrid, GridSelectionHLPure, ButtonHLPure, PrimaryBtn, LabelModalPure, LabelHLPure } from "../../pures";
import { useTranslation } from "react-i18next";
import ModalRequstDelete from "../../pures/modal-delete/modal-delete";
import DialogPdfByVolumePure from "../dialog-pdf-by-volume/dialog-pdf-by-volume.pure";
import DialogEditRegistryByVolumePure from "../dialog-edit-registry-by-volume/dialog-edit-registry-by-volume.pure";
import CellActionsByVolume from "./cellActionsByVolume";
import CellStateByVolume from "./cellStateByVolume";
import { Label } from "@progress/kendo-react-labels";
import { Checkbox } from "@progress/kendo-react-inputs";
import { OnboardingSignaturePdfDark } from "../../../assets/logos/icons";
import { Tooltip } from "@progress/kendo-react-tooltip";

const HeaderColumns = (props) => {
  return (
    <span className={(props.title === props.t("signRequestByVolumeSignersListViewPanelPure.grid.title.1")) ? "grid-header-one" : "grid-headers"}>{props.title}</span>
  );
};

const CellColumns = (props) => {
  let label = ''
  if(props.col === 1) label = props.dataItem.fileName
  if(props.col === 2) label = props.dataItem.email
  if(props.col === 3) label = `${props.dataItem.firstName} ${props.dataItem.lastName}`

  return( 
    <td>
      <p className={(props.col === 1) ?'grid-cell-titles-margin-left' : 'grid-cell-subtitles'}>{label}</p>
    </td>
  );
};

const CellState = (props) => {
  return(
    <td>
      {Object.values(props.pdfFiles).find((file) =>
        file.name === props.dataItem.fileName ? true : false
        ) ? (
          <Tooltip
            tooltipClassName="tooltipGeneralStyle"
            anchorElement="target"
            position="top"
            openDelay={300}
          >
            <span
              className="icon-fileStatus"
              onClick={() =>
                props.toggleDialogPdfPreview(props.setDataItem(props.dataItem))
              }
            >
              <img
                className="k-icon"
                src={OnboardingSignaturePdfDark}
                alt="icon"
                title="Visualizar PDF correspondiente de registro"
                style={{ paddingLeft: "35px" }}
              ></img>
            </span>
          </Tooltip>
        ) : (
          <p className={'grid-cell-subtitles'}>X</p>
      )}
    </td>
  )
}

const CellActions = (props) => {
return (
    <div className="signRequestByVolumeSignersListViewPanelPure-btns-actions">
      <PrimaryBtn
        submit
        text={props.t("signRequestByVolumeSignersListViewPanelPure.grid.btns.edit")}
        onClick={() => {
          props.toggleDialog(props.setDataItem(props.dataItem));
        }}
      />
      <span
        className="button-signers delete"
        onClick={() => {
          props.toggleDialogDelete(props.setDataItem(props.dataItem));
        }}
      >
        <i className="k-icon k-i-delete k-i-trash"></i>
      </span>
    </div>
  );
}

const SignRequestByVolumeSignersListViewPanelPure = (props) => {
  let {
    pdfFiles
  } = props
  
  const { t } = useTranslation();
  const [showDialog, setShowDialog] = useState(false);
  const [showDialogDelete, setShowDialogDelete] = useState(false);
  const [showDialogPdfPreview, setShowDialogPdfPreview] = useState(false);
  const [dataItem, setDataItem] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [textError, setTextError] = useState("");

  const toggleDialog = () => setShowDialog(!showDialog);

  const toggleDialogDelete = () => {
    setShowDialogDelete(!showDialogDelete);
  };

  const toggleDialogPdfPreview = () => {
    setShowDialogPdfPreview(!showDialogPdfPreview);
  };

  const deleteRecordAndFile = (dataItem) => {
    props.handleDeleteRecord(dataItem.fileName);
  };

  let allHeadersColumns = (props) => <HeaderColumns {...props} t={t} />
  let cellOne = (props) => <CellColumns {...props} t={t} col={1}/>
  let cellTwo = (props) => <CellColumns {...props} t={t} col={2}/>
  let cellThree = (props) => <CellColumns {...props} t={t} col={3}/>
  let cellFour = (props) => <CellState {...props} t={t} toggleDialogPdfPreview={toggleDialogPdfPreview} setDataItem={setDataItem}  pdfFiles = {pdfFiles} col={4}/>
  let cellSix = (props) => <CellActions {...props} t={t}  toggleDialog ={toggleDialog}  toggleDialogDelete={toggleDialogDelete} toggleDialogPdfPreview={toggleDialogPdfPreview} setDataItem={setDataItem}  pdfFiles = {pdfFiles} col={6}/>

  let widthCellOne = '60px'
  let widthCellTwo = '90px'
  let widthCellThree = '100px'
  let widthCellFour = '40px'
  let widthCellSix = '70px'

  return (
    <>
    <div item className="uploadIdentityDocument-grid-documents">
      <GridSelectionHLPure
        styleGeneral={false}
        pageable={true}
        skip={0}
        take={6}
        dataGrid={props.csvJsonArray}
        
        titleRow1={t("signRequestByVolumeSignersListViewPanelPure.grid.title.1")}
        headerColumnOne={allHeadersColumns}
        cellColumnOne={cellOne}
        widthColumnOne={widthCellOne}
        minResizableWidth1={widthCellOne}
        
        columnTwo={true}
        titleRow2={t("signRequestByVolumeSignersListViewPanelPure.grid.title.2")}
        headerColumnTwo={allHeadersColumns}
        cellColumnTwo={cellTwo}
        widthColumnTwo={widthCellTwo}
        minResizableWidth2={'auto'}

        columnThree={true}
        titleRow3={t("signRequestByVolumeSignersListViewPanelPure.grid.title.3")}
        headerColumnThree={allHeadersColumns}
        cellColumnThree={cellThree}
        widthColumnThree={widthCellThree}
        minResizableWidth3={"auto"}

        columnFour={true}
        titleRow4={t("signRequestByVolumeSignersListViewPanelPure.grid.title.4")}
        headerColumnFour={allHeadersColumns}
        cellColumnFour={cellFour}
        widthColumnFour={widthCellFour}
        minResizableWidth4={widthCellFour}

        columnSix={true}
        titleRow6={t("signRequestByVolumeSignersListViewPanelPure.grid.title.6")}
        headerColumnSix={allHeadersColumns}
        cellColumnSix={cellSix}
        widthColumnSix={widthCellSix}
        minResizableWidth6={widthCellSix}

        styleGrid={{ height: 'auto' }}
      />
    </div> 
      <div>
      {/* <SimpleKendoGrid list={props.csvJsonArray} numberOfItems={7}>
        <Column
          field="file"
          title="Archivo"
          cell={({ dataItem }) => (
            <td className="cell-item-file">{dataItem.fileName}</td>
          )}
        />
        <Column
          field="mail"
          title="Correo"
          width="auto"
          cell={({ dataItem }) => (
            <td className="cell-item-file">{dataItem.email}</td>
          )}
        />
        <Column
          field="signer"
          title="Firmante"
          width="auto"
          cell={({ dataItem }) => (
            <td className="cell-item-file">
              {dataItem.firstName} {dataItem.lastName}
            </td>
          )}
        />
        <Column
          field="state"
          title="Estado"
          width="auto"
          cell={CellStateByVolume({
            toggleDialogPdfPreview: toggleDialogPdfPreview,
            setDataItem: setDataItem,
            pdfFiles: props.pdfFiles,
          })}
        />
        <Column
          field="action"
          title="Acción"
          width="auto"
          cell={CellActionsByVolume({
            toggleDialog: toggleDialog,
            toggleDialogPdfPreview: toggleDialogPdfPreview,
            setDataItem: setDataItem,
            toggleDialogDelete: toggleDialogDelete,
            pdfFiles: props.pdfFiles,
          })}
        />
      </SimpleKendoGrid> */}
      {showDialog && (
        <DialogEditRegistryByVolumePure
          toggleDialog={toggleDialog}
          dataItem={dataItem}
          validator={props.validator}
          handleEditRegister={props.handleEditRegister}
          isLoading={isLoading}
          success={success}
          error={error}
          textError={textError}
          pdfFiles={props.pdfFiles}
        />
      )}
      {showDialogDelete && (
        <ModalRequstDelete
          deleteText={ <LabelModalPure label={`${t("signRequestByVolumeSignersListViewPanelPure.delete.question")} ${dataItem.fileName}?`}/>}
          isLoading={isLoading}
          success={success}
          error={error}
          textError={textError}
          deleteElement={() => deleteRecordAndFile(dataItem)}
          toggleDialog={toggleDialogDelete}
          isDeleteByVolume={true}
        />
      )}
      {showDialogPdfPreview && (
        <DialogPdfByVolumePure
          cancel={toggleDialogPdfPreview}
          title={dataItem.fileName}
          dataItem={dataItem}
          pdfFiles={props.pdfFiles}
        />
      )}
      <div className="total-confirmation">
        <LabelHLPure 
          text={`${t("signRequestByVolumeSignersListViewPanelPure.total.request")} ${props.csvJsonArray.length}, ${t("signRequestByVolumeSignersListViewPanelPure.docs.upload")} ${props.pdfFiles.length}`}
          fontSize={'16px'}
          showTooltip={false}
        />
        <div className="signRequestByVolumeSignersListViewPanelPure-checkbox">
          <Checkbox onChange={props.setAllFilesUploaded} /> 
          <LabelHLPure 
          text={`${t("signRequestByVolumeSignersListViewPanelPure.check.confirm")}`}
          fontSize={'16px'}
          showTooltip={false}
        />
        </div>
      </div>
    </div>
    </>
  );
};

export default SignRequestByVolumeSignersListViewPanelPure;
